import {
    tss,
} from 'app/tss'

export default tss
    .withParams<{ isDetailsView: boolean }>()
    .create(({
        theme,
        isDetailsView,
    }) => {
        return {
            gridWrapper: {
                width: '100%',
            },
            dataGridContainer: {
                height: '100%',
                '& .MuiDataGrid-root': {
                    borderTopRightRadius: `${isDetailsView ? 0 : 4}px !important`,
                    borderBottomRightRadius: `${isDetailsView ? 0 : 4}px !important`,
                },
                '& .MuiDataGrid-mainContent': {
                    background: `${theme.palette.secondary[50]}`,
                    '.MuiDataGrid-footerContainer': {
                        backgroundColor: isDetailsView ? 'inherit' : theme.palette.secondary[50],
                    },
                },
            },
        }
    })
